import ProgressBar from './styled';

export default ProgressBar;
